/**
 * 配信同意バナー
 * 同意が未確認（marketingConsent === null）のログイン済みユーザーに一度だけ表示する。
 * Googleログイン等で新規登録フォームを通らないユーザーの同意回収が主目的（strategy.md 7b）。
 */

import React, { useState } from "react";
import { Bell, X } from "lucide-react";
import { useUserProfile, PENDING_CONSENT_KEY } from "../../../contexts/UserProfileContext";

export const MarketingConsentBanner: React.FC = () => {
  const { profile, isLoaded, updateProfile } = useUserProfile();
  const [dismissed, setDismissed] = useState(false);

  // プロファイル取得前・確認済み・保存待ちの同意がある場合は出さない
  if (
    dismissed ||
    !isLoaded ||
    profile.marketingConsent !== null ||
    localStorage.getItem(PENDING_CONSENT_KEY) !== null
  ) {
    return null;
  }

  const answer = (consent: boolean) => {
    setDismissed(true);
    updateProfile({ marketingConsent: consent });
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6 pointer-events-none">
      <div
        role="dialog"
        aria-label="お知らせメールの受信設定"
        className="pointer-events-auto max-w-lg mx-auto rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg p-4 sm:p-5"
      >
        <div className="flex items-start gap-3">
          <Bell className="w-5 h-5 mt-0.5 shrink-0 text-blue-500" aria-hidden="true" />
          <div className="flex-1">
            <p className="text-sm font-medium text-slate-900 dark:text-white">
              試験制度の変更をメールでお知らせしますか？
            </p>
            <p className="mt-1 text-xs text-slate-500 dark:text-slate-400 leading-relaxed">
              CBT化などの制度変更アラートや新機能のお知らせ、ユーザーインタビュー等のご案内をお届けします。設定はいつでも変更できます。
            </p>
            <div className="mt-3 flex gap-2">
              <button
                onClick={() => answer(true)}
                className="min-h-[44px] px-4 py-2 rounded-xl text-sm font-medium bg-slate-900 dark:bg-slate-200 text-white dark:text-slate-900 hover:opacity-90 transition-opacity"
              >
                受け取る
              </button>
              <button
                onClick={() => answer(false)}
                className="min-h-[44px] px-4 py-2 rounded-xl text-sm text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              >
                受け取らない
              </button>
            </div>
          </div>
          <button
            onClick={() => setDismissed(true)}
            aria-label="閉じる"
            className="p-2 -m-1 text-slate-400 hover:text-slate-500 dark:hover:text-slate-300"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
